module.exports = __webpack_public_path__ + "img/m7.2e1afd0c.jpg";